// Utilitaire pour charger la liste des credentials requis pour chaque exchange
import requiredCredentials from './required-credentials.json';

export function getRequiredCredentialsForExchange(exchange) {
  if (!exchange) return ['apiKey', 'secret'];
  const creds = requiredCredentials[exchange.toLowerCase()];
  if (!creds) return ['apiKey', 'secret'];
  return creds;
}
